import type { ReactNode } from "react";

/**
 * Renders plain text that may contain simple Markdown emphasis markers
 * (**bold** and *italic*) as React nodes, instead of showing the raw
 * "**" characters. Line breaks are preserved by the caller via
 * `white-space: pre-wrap` on the containing element.
 */
export function renderFormattedText(text: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  // Matches **bold** or *italic* (non-greedy, no nested/empty matches).
  const pattern = /\*\*(.+?)\*\*|\*(.+?)\*/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let key = 0;

  while ((match = pattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(text.slice(lastIndex, match.index));
    }

    if (match[1] !== undefined) {
      nodes.push(<strong key={key++}>{match[1]}</strong>);
    } else {
      nodes.push(<em key={key++}>{match[2]}</em>);
    }

    lastIndex = pattern.lastIndex;
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes;
}
